import React from 'react';
import styles from '../../NewPage.module.css';
import closeSvg from '../../../../../../../assets/Close.svg';
import increase from '../../../../../../../assets/increase.svg';
import decrease from '../../../../../../../assets/decrease.svg';
import { AiOutlinePlus } from 'react-icons/ai';
import Draggable from 'react-draggable';
import {
  handleBlink,
  handleGraphInterval,
  handleHideWidget,
  handleHorizontalMovementValues,
  handleLineStyle,
  handleVerticalMovementValues,
  handleYRange,
} from '../ExtraFunctions';
import { updateTagByName } from '../VNetTagUpdate';

export const PropertiesModal = ({
  isBgColor,
  handleChangeBg,
  handleIncreaseFontSize,
  handleDecreaseFontSize,
  handleFontSizeInputChange,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setTextAlignHorizontally,
  setTextAlignVertically,
  data,
}) => {
  if (!isBgColor) return null;

  const {
    currentDevice,
    bgColor,
    textColor,
    fontSize,
    textBgColor,
    textFontSize,
    addedText,
    textAlignVertically,
    textAlignHorizontally,
    setIsBgColor,
    setBorderRadius,
    borderRadius,
    setIsTransperant,
    isTransparent,
  } = data;
  return (
    <div className={styles.addNewTag}>
      <div className={styles.bgColorContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsBgColor(false)}
        >
          <img src={closeSvg} alt="" />
        </button>

        <h2 className={styles.modalHeader}>Properties</h2>

        {(currentDevice === 'Text' ||
          currentDevice === 'Link' ||
          currentDevice === 'Square' ||
          currentDevice === 'Circle') && (
          <input
            type="text"
            placeholder="Add Text"
            defaultValue={addedText}
            className={styles.addTextInput}
            onChange={(e) => setAddedText(e.target.value)}
          />
        )}

        {currentDevice === 'Text' && (
          <div className={styles.upDown}>
            <span className={styles.bgColorText}>Transparent : </span>
            <select
              style={{
                background: 'transparent',
                border: '1px solid black',
                borderRadius: '0.625rem',
                padding: '0.3rem 0.7rem',
                outline: 'none',
                cursor: 'pointer',
              }}
              onChange={(e) => {
                e.stopPropagation();
                setIsTransperant(e.target.value === 'true');
              }}
              defaultValue={isTransparent ? 'true' : 'false'}
            >
              <option value="false">False</option>
              <option value="true">True</option>
            </select>
          </div>
        )}

        {currentDevice !== 'Clock' &&
          currentDevice !== 'DigitalIO' &&
          currentDevice !== 'Gauge' && (
            <div className={styles.bgWrapper}>
              <span className={styles.bgColorText}>Background-color : </span>
              <input
                type="color"
                className={styles.colorInput}
                defaultValue={
                  currentDevice === 'Display' ? bgColor : textBgColor
                }
                onChange={
                  currentDevice === 'Display'
                    ? (e) => setBgColor(e.target.value)
                    : (e) => setTextBgColor(e.target.value)
                }
              />
            </div>
          )}

        {currentDevice !== 'Polygone' &&
          currentDevice !== 'Clock' &&
          currentDevice !== 'DigitalIO' &&
          currentDevice !== 'Gauge' &&
          currentDevice !== 'ProgressBar' &&
          currentDevice !== 'Line' &&
          currentDevice !== 'Switch' && (
            <div className={styles.bgWrapper}>
              <span className={styles.bgColorText}>Text-color : </span>
              <input
                type="color"
                className={styles.colorInput}
                defaultValue={
                  currentDevice === 'Display' ? textColor : data.widgetTextColor
                }
                onChange={
                  currentDevice === 'Display'
                    ? (e) => setTextColor(e.target.value)
                    : (e) => data.setWidgetTextColor(e.target.value)
                }
              />
            </div>
          )}

        {currentDevice !== 'Polygone' &&
          currentDevice !== 'Pipe' &&
          currentDevice !== 'Line' &&
          currentDevice !== 'Switch' && (
            <div className={styles.bgWrapper}>
              <span className={styles.bgColorText}>Font-size : </span>
              <input
                type="number"
                className={styles.time}
                value={currentDevice === 'Display' ? fontSize : textFontSize}
                min="7"
                onChange={handleFontSizeInputChange}
              />
              <div className={styles.upDown}>
                <img
                  src={increase}
                  alt=""
                  className={styles.upDownImg}
                  onClick={handleIncreaseFontSize}
                />
                <img
                  src={decrease}
                  alt=""
                  className={styles.upDownImg}
                  onClick={handleDecreaseFontSize}
                />
              </div>
            </div>
          )}

        {(currentDevice === 'Text' || currentDevice === 'Link') && (
          <>
            <div className={styles.upDown}>
              <span>Align Vertically : </span>
              <select
                style={{
                  background: 'transparent',
                  border: '1px solid black',
                  borderRadius: '0.625rem',
                  padding: '0.3rem 0.7rem',
                  outline: 'none',
                  cursor: 'pointer',
                }}
                onChange={(e) => setTextAlignVertically(e.target.value)}
                value={textAlignVertically}
              >
                <option value="">select alignment</option>
                <option value="start">Start</option>
                <option value="center">Center</option>
                <option value="end">End</option>
              </select>
            </div>

            <div className={styles.upDown}>
              <span>Align Horizontally : </span>
              <select
                style={{
                  background: 'transparent',
                  border: '1px solid black',
                  borderRadius: '0.625rem',
                  padding: '0.3rem 0.7rem',
                  outline: 'none',
                  cursor: 'pointer',
                }}
                onChange={(e) => setTextAlignHorizontally(e.target.value)}
                value={textAlignHorizontally}
              >
                <option value="">select alignment</option>
                <option value="start">Start</option>
                <option value="center">Center</option>
                <option value="end">End</option>
              </select>
            </div>
          </>
        )}

        {currentDevice === 'Square' && (
          <div className={styles.bgWrapper}>
            <div className={styles.bgColorText}>Border-Radius</div>
            <input
              type="number"
              className={styles.addTextInput}
              onChange={(e) => setBorderRadius(Number(e.target.value))}
              defaultValue={borderRadius || 0}
            />
          </div>
        )}

        <button
          className={styles.saveTimePeriod}
          onClick={() => handleChangeBg(data)}
        >
          save
        </button>
      </div>
    </div>
  );
};

export const RangeModal = ({
  isRangeModel,
  setIsRangeModal,
  currentDevice,
  handleRangeSave,
  ...restProps
}) => {
  if (!isRangeModel) return null;

  return (
    <div className={styles.addNewTag}>
      <div className={styles.range}>
        <img
          src={closeSvg}
          className={styles.closeImages}
          onClick={() => setIsRangeModal(false)}
          alt=""
        />

        <div className={styles.rangeContainer}>
          {currentDevice !== 'CircularProgress' && (
            <input
              type="number"
              className={styles.rangeInput}
              placeholder="Minimum Value"
              id="minValue"
            />
          )}
          <input
            type="number"
            className={styles.rangeInput}
            placeholder="Maximum Value"
            id="maxValue"
          />
        </div>

        <div
          className={styles.saveWrapper}
          onClick={() =>
            handleRangeSave({
              setIsRangeModal,
              currentDevice,
              ...restProps,
            })
          }
        >
          <button className={styles.saveChannelBtn}>Save</button>
        </div>
      </div>
    </div>
  );
};

export const ChannelsModal = ({
  isChannels,
  setIsChannels,
  currentDevice,
  tableData = [],
  apiChannels = [],
  widgetData,
  plusIcon,
  displaySelectTag,
  handleSelectChange,
  handlePlusIcon,
  WidgetSelectChannel,
  lampStatus,
  setLampStatus,
  selectedDevice,
  ...restProps
}) => {
  if (!isChannels) return null;
  console.log('widgetData in ChannelsModal: ', widgetData);
  // const channelList =
  //   tableData && tableData.length > 0
  //     ? tableData
  //     : apiChannels.map((item) => ({
  //         Header: item,
  //       }));

  const apiChannelList = (apiChannels || []).map((channel) => ({
    Header: channel,
  }));

  const liveChannelList = (tableData || []).map((channel) => ({
    Header: channel.Header,
  }));

  const channelList = [
    ...apiChannelList,
    ...liveChannelList.filter(
      (liveChannel) =>
        !apiChannelList.some(
          (apiChannel) => apiChannel.Header === liveChannel.Header,
        ),
    ),
  ];

  // console.log("isChannels : ", isChannels, ", tableData : ",tableData);
  return (
    <div className={styles.addNewTag}>
      <div className={styles.overflowContainer}>
        <div className={styles.channels}>
          <img
            src={closeSvg}
            className={styles.closeImages}
            alt=""
            onClick={() => setIsChannels(false)}
          />

          <div className={styles.selectChannel}>
            <div
              className={
                plusIcon
                  ? `${styles.pvSection} ${styles.newPV}`
                  : styles.pvSection
              }
            >
              {currentDevice === 'PieChart' ||
              currentDevice === 'LineChart' ||
              currentDevice === 'BarChart' ||
              currentDevice === 'Histogram' ||
              currentDevice === 'Gauge' ||
              currentDevice === 'ProgressBar' ||
              currentDevice === 'Grid' ||
              currentDevice === 'Table' ||
              currentDevice === 'Motor' ||
              currentDevice === 'Display' ||
              currentDevice === 'Doughnut' ||
              currentDevice === 'CircularProgress' ||
              currentDevice === 'Slider' ||
              currentDevice === 'Lamp' ||
              currentDevice === 'Switch' ||
              currentDevice === 'Square' ||
              currentDevice === 'Circle' ||
              currentDevice === 'Text' ||
              currentDevice === 'Pipe' ? null : (
                <div className={styles.pv}>PV :</div>
              )}

              {/* <select
                                id="pvChannels"
                                className={styles.availableChannels}
                                onChange={handleSelectChange}
                            >
                                <option value="">Select Channel</option>
                                {tableData?.map((data, i) => (
                                    <option key={i}>{data.Header}</option>
                                ))}
                            </select> */}

              <select
                id="pvChannels"
                className={styles.availableChannels}
                onChange={handleSelectChange}
              >
                <option value="">Select Channel</option>

                {channelList.map((data, i) => (
                  <option key={i} value={data.Header}>
                    {data.Header}
                  </option>
                ))}
              </select>

              {plusIcon &&
                displaySelectTag?.map((tag, index) => (
                  <select
                    key={index}
                    id={`chartChannels${index}`}
                    className={styles.availableChannels}
                    onChange={handleSelectChange}
                  >
                    <option value="">Select Channel</option>
                    {/* {tableData?.map((data, i) => (
                                            <option key={i}>{data.Header}</option>
                                        ))} */}
                    {channelList.map((data, i) => (
                      <option key={i} value={data.Header}>
                        {data.Header}
                      </option>
                    ))}
                  </select>
                ))}

              {plusIcon && (
                <button className={styles.plusBtn} onClick={handlePlusIcon}>
                  <AiOutlinePlus />
                </button>
              )}
            </div>

            {/* SV Sections */}
            {(currentDevice === 'Controller' ||
              currentDevice === 'FlowMeter' ||
              currentDevice === 'EnergyMeter' ||
              currentDevice === 'DigitalIO') && (
              <div className={styles.svSection}>
                <div className={styles.sv}>SV :</div>
                <select id="svChannels" className={styles.availableChannels}>
                  <option value="">Select Channel</option>
                  {channelList?.map((data, i) => (
                    <option key={i}>{data.Header}</option>
                  ))}
                </select>
              </div>
            )}

            {currentDevice === 'EnergyMeter' && (
              <>
                <div className={styles.svSection2}>
                  <select id="svChannel2" className={styles.availableChannels}>
                    <option value="">Select Channel</option>
                    {channelList?.map((data, i) => (
                      <option key={i}>{data.Header}</option>
                    ))}
                  </select>
                </div>

                <div className={styles.svSection3}>
                  <select id="svChannel3" className={styles.availableChannels}>
                    <option value="">Select Channel</option>
                    {channelList?.map((data, i) => (
                      <option key={i}>{data.Header}</option>
                    ))}
                  </select>
                </div>
              </>
            )}

            {currentDevice === 'Lamp' &&
              lampStatus?.map((lamp, i) => (
                <div className={styles.lampStatusWrapper} key={lamp.id}>
                  <div className={styles.lampChannelSection}>
                    <span className={styles.bgColorText}>
                      Condition Value :
                    </span>
                    <input
                      type="text"
                      value={lamp.conditionValue}
                      className={styles.addTextInput}
                      onChange={(e) =>
                        setLampStatus((prev) =>
                          prev.map((item) =>
                            item.id === lamp.id
                              ? { ...item, conditionValue: e.target.value }
                              : item,
                          ),
                        )
                      }
                    />
                  </div>
                  <div className={styles.lampChannelSection}>
                    <span className={styles.bgColorText}>Color:</span>
                    <input
                      type="color"
                      value={lamp.color}
                      onChange={(e) =>
                        setLampStatus((prev) =>
                          prev.map((item) =>
                            item.id === lamp.id
                              ? { ...item, color: e.target.value }
                              : item,
                          ),
                        )
                      }
                    />
                  </div>
                </div>
              ))}

            <div className={styles.saveWrapper}>
              {currentDevice === 'Lamp' && (
                <button
                  className={styles.saveChannelBtn}
                  onClick={() =>
                    setLampStatus([
                      ...lampStatus,
                      { id: Date.now(), conditionValue: '', color: '' },
                    ])
                  }
                >
                  Add New Status
                </button>
              )}

              {currentDevice === 'Lamp' && (
                <button
                  className={styles.saveChannelBtn}
                  onClick={() =>
                    setLampStatus((prev) =>
                      prev.length > 1 ? prev.slice(0, -1) : prev,
                    )
                  }
                >
                  Delete Last Status
                </button>
              )}

              <button
                className={styles.saveChannelBtn}
                onClick={() =>
                  WidgetSelectChannel({
                    setIsChannels,
                    currentDevice,
                    lampStatus,
                    ...restProps,
                  })
                }
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ChannelCheckboxModal = ({
  setIsChannelCheckBox,
  handleAllSelect,
  selectAllCheck,
  tableData,
  handleCheckBox,
  handleSaveCheckBox,
  currentDevice,
  tempTabIndexGrid,
  activeTabIndex,
  tempImages,
  selectedDevice,
  clickedDeviceIndex,
  gridChannels,
  setTempImages,
  setUpdatedImages,
  setTempTabIndexGrid,
  setUpdatedTabIndexGrid,
  multipleGrid,
  setMultipleGrid,
  setGridChannels,
}) => {
  return (
    <div className={styles.checkBoxParent}>
      <Draggable bounds="parent">
        <div className={styles.channelCheckBoxContainer}>
          <button
            className={styles.closeImages}
            onClick={() => setIsChannelCheckBox(false)}
          >
            <img src={closeSvg} alt="close" />
          </button>

          <div className={styles.selectAllOption}>
            <input
              type="checkbox"
              id="selectAllOption"
              onChange={handleAllSelect}
              checked={selectAllCheck}
            />
            <span>Select All</span>
          </div>

          <div className={styles.checkBoxesWrapper}>
            {tableData.map((data, index) => (
              <div key={index} className={styles.checkBoxes}>
                <input
                  type="checkbox"
                  name="checkBox"
                  onChange={(event) =>
                    handleCheckBox(event, index, data.Header)
                  }
                  className={styles.checkBoxInput}
                  id={`checkBox${index}`}
                />
                <span>{data.Header}</span>
              </div>
            ))}
          </div>

          <div className={styles.saveWrapper}>
            <button
              className={styles.saveChannelBtn}
              onClick={() =>
                handleSaveCheckBox({
                  setIsChannelCheckBox,
                  currentDevice,
                  tempTabIndexGrid,
                  activeTabIndex,
                  tempImages,
                  selectedDevice,
                  clickedDeviceIndex,
                  gridChannels,
                  setTempImages,
                  setUpdatedImages,
                  setTempTabIndexGrid,
                  setUpdatedTabIndexGrid,
                  multipleGrid,
                  setMultipleGrid,
                  setGridChannels,
                })
              }
            >
              Save
            </button>
          </div>
        </div>
      </Draggable>
    </div>
  );
};

export const RenameModal = ({
  selectedTab,
  isRenameModel,
  addNewTag,
  renameDeviceModal,
  setIsRenameModel,
  setAddNewTag,
  setRenameDeviceModal,
  tabNameInput,
  setTabNameInput,
  handleSaveRenameTab,
  handleSaveTab,
  WidgetRename,
  currentDevice,
  tempTabIndexDevices,
  activeTabIndex,
  selectedDevice,
  clickedDeviceIndex,
  tempImages,
  setTempImages,
  setUpdatedImages,
  multipleDevices,
  setMultipleDevices,
  setDevicesName,
  devicesName,
  setIndexesDeviceName,
  indexesDeviceName,
  tempTabIndexController,
  multipleController,
  setMultipleController,
  tempTabIndexIO,
  multipleIO,
  setMultipleIO,
  tempTabIndexFlowM,
  multipleFlowM,
  setMultipleFlowM,
  tempTabIndexEnergyM,
  multipleEnergyM,
  setMultipleEnergyM,
}) => {
  return (
    <div className={styles.addNewTag}>
      <div className={styles.newTabContainer}>
        {(isRenameModel || addNewTag || renameDeviceModal) && (
          <>
            <button
              onClick={() =>
                isRenameModel
                  ? setIsRenameModel(false)
                  : addNewTag
                    ? setAddNewTag(false)
                    : setRenameDeviceModal(false)
              }
              className={styles.closeBtn}
            >
              <img src={closeSvg} alt="" className={styles.closeImg} />
            </button>
          </>
        )}

        {isRenameModel && (
          <>
            <input
              type="text"
              placeholder="Enter New Tab Name"
              className={styles.tabNameInput}
              onChange={(e) => setTabNameInput(e.target.value)}
              defaultValue={isRenameModel && selectedTab}
            />
            <button
              className={styles.saveModel}
              onClick={handleSaveRenameTab}
              disabled={!tabNameInput}
            >
              Save
            </button>
          </>
        )}

        {addNewTag && (
          <>
            <input
              type="text"
              placeholder="Tab Name"
              className={styles.tabNameInput}
              onChange={(e) => setTabNameInput(e.target.value)}
            />
            <button
              className={styles.saveModel}
              onClick={handleSaveTab}
              disabled={!tabNameInput}
            >
              Save
            </button>
          </>
        )}

        {renameDeviceModal && (
          <>
            <input
              type="text"
              placeholder="Device Name"
              className={styles.tabNameInput}
              onChange={(e) => setTabNameInput(e.target.value)}
            />
            <button
              className={styles.saveModel}
              disabled={!tabNameInput}
              onClick={() =>
                WidgetRename({
                  setRenameDeviceModal,
                  currentDevice,
                  tempTabIndexDevices,
                  activeTabIndex,
                  selectedDevice,
                  clickedDeviceIndex,
                  tabNameInput,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  multipleDevices,
                  setMultipleDevices,
                  setDevicesName,
                  devicesName,
                  setIndexesDeviceName,
                  indexesDeviceName,
                  tempTabIndexController,
                  multipleController,
                  setMultipleController,
                  tempTabIndexIO,
                  multipleIO,
                  setMultipleIO,
                  tempTabIndexFlowM,
                  multipleFlowM,
                  setMultipleFlowM,
                  tempTabIndexEnergyM,
                  multipleEnergyM,
                  setMultipleEnergyM,
                })
              }
            >
              Save
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export const TimePeriodModal = ({
  handleCloseTimePeriod,
  handleEndTimeSelect,
  endSelect,
  endHours,
  endMinutes,
  handleEndChange,
  handleEndIncrease,
  handleEndDecrease,
  handleSaveTimePeriod,
  setIsTimePeriod,
  currentDevice,
  multipleLineCharts,
  tempTabIndexLineChart,
  activeTabIndex,
  selectedDevice,
  clickedDeviceIndex,
  tempImages,
  setTempImages,
  setUpdatedImages,
  setTempTabIndexLineChart,
  setUpdatedTabIndexLineChart,
  setMultipleLineCharts,
  multipleHistogram,
  tempTabIndexHistogram,
  setTempTabIndexHistogram,
  setUpdatedTabIndexHistogram,
  setMultipleHistogram,
}) => {
  return (
    <div className={styles.addNewTag}>
      <div className={styles.timePeriodModal}>
        <img
          src={closeSvg}
          alt=""
          className={styles.closeImages}
          onClick={handleCloseTimePeriod}
        />

        <div className={styles.endTime}>
          <select
            id="endTime"
            onClick={handleEndTimeSelect}
            className={styles.timePeriodSelect}
          >
            <option>Hours</option>
            <option>Minutes</option>
          </select>

          {endSelect === 'Hours' && (
            <div className={styles.timeWrapper}>
              <input
                type="number"
                className={styles.time}
                value={endHours}
                onChange={handleEndChange}
              />
              <div className={styles.upDown}>
                <img
                  src={increase}
                  alt=""
                  className={styles.upDownImg}
                  onClick={handleEndIncrease}
                />
                <img
                  src={decrease}
                  alt=""
                  className={styles.upDownImg}
                  onClick={handleEndDecrease}
                />
              </div>
            </div>
          )}

          {endSelect === 'Minutes' && (
            <div className={styles.timeWrapper}>
              <input
                type="number"
                className={styles.time}
                value={endMinutes}
                onChange={handleEndChange}
              />
              <div className={styles.upDown}>
                <img
                  src={increase}
                  alt=""
                  className={styles.upDownImg}
                  onClick={handleEndIncrease}
                />
                <img
                  src={decrease}
                  alt=""
                  className={styles.upDownImg}
                  onClick={handleEndDecrease}
                />
              </div>
            </div>
          )}
        </div>

        <button
          className={styles.saveTimePeriod}
          onClick={() =>
            handleSaveTimePeriod({
              setIsTimePeriod,
              currentDevice,
              multipleLineCharts,
              tempTabIndexLineChart,
              activeTabIndex,
              selectedDevice,
              clickedDeviceIndex,
              tempImages,
              endHours,
              endMinutes,
              setTempImages,
              setUpdatedImages,
              setTempTabIndexLineChart,
              setUpdatedTabIndexLineChart,
              setMultipleLineCharts,
              multipleHistogram,
              tempTabIndexHistogram,
              setTempTabIndexHistogram,
              setUpdatedTabIndexHistogram,
              setMultipleHistogram,
            })
          }
        >
          Save
        </button>
      </div>
    </div>
  );
};

export const ChangeSVModal = ({
  setIsChangeSV,
  handleChangeSV,
  currentDevice,
  loginSid,
  comid,
  compvtkey,
  key,
  dispatch,
  deviceGroupName,
  deviceName,
  toast,
  tagGroupName,
  vNetSid,
  setUpdateValue,
}) => {
  return (
    <div className={styles.addNewTag}>
      <div className={styles.changeSVContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsChangeSV(false)}
        >
          <img src={closeSvg} alt="close" />
        </button>

        <h2 className={styles.modalHeader}>Properties</h2>

        <input
          type="number"
          className={styles.changeSVInput}
          placeholder="Current Page Rows"
          id="currentPageRows"
          required
        />

        <input
          type="number"
          className={styles.changeSVInput}
          placeholder="Current Page"
          id="currentPage"
          required
        />

        <input
          type="text"
          className={styles.changeSVInput}
          placeholder="Tag Name (Case Sensitive)"
          id="tagName"
          required
        />

        <input
          type="number"
          className={styles.changeSVInput}
          placeholder="Value"
          id="changeSV"
          required
        />

        <button
          className={styles.saveTimePeriod}
          onClick={() =>
            handleChangeSV({
              currentDevice,
              loginSid,
              comid,
              compvtkey,
              key,
              dispatch,
              deviceGroupName,
              deviceName,
              toast,
              tagGroupName,
              setIsChangeSV,
            })
          }
        >
          Save
        </button>
      </div>
    </div>
  );
};

export const ChangeIOText = ({
  isChangeText,
  setIsChangeText,
  currentDevice,
  tempTabIndexIO,
  activeTabIndex,
  tempImages,
  selectedDevice,
  clickedDeviceIndex,
  setTempImages,
  setUpdatedImages,
  setTempTabIndexIO,
  setUpdatedTabIndexIO,
  multipleIO,
  setMultipleIO,
  onText,
  setOnText,
  offText,
  setOffText,
  handleIOText,
  setUpdatedTabIndexSquare,
  setTempTabIndexSquare,
  multipleSquare,
  setMultipleSquare,
  tempTabIndexSquare,
  setUpdatedTabIndexCircle,
  setTempTabIndexCircle,
  multipleCircle,
  setMultipleCircle,
  tempTabIndexCircle,
}) => {
  if (!isChangeText) return null;

  return (
    <div className={styles.addNewTag}>
      <div className={styles.bgColorContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsChangeText(false)}
        >
          <img src={closeSvg} alt="" />
        </button>

        <div className={styles.changeTextInfo}>
          <span className={styles.bgColorText}>On Text:</span>
          <input
            type="text"
            className={styles.addTextInput}
            placeholder="On Text"
            onChange={(e) => setOnText(e.target.value)}
          />
        </div>

        <div className={styles.changeTextInfo}>
          <span className={styles.bgColorText}>Off Text:</span>
          <input
            type="text"
            className={styles.addTextInput}
            placeholder="Off Text"
            onChange={(e) => setOffText(e.target.value)}
          />
        </div>

        <button
          className={styles.saveTimePeriod}
          onClick={() => {
            handleIOText({
              currentDevice,
              tempTabIndexIO,
              activeTabIndex,
              tempImages,
              selectedDevice,
              clickedDeviceIndex,
              setTempImages,
              setUpdatedImages,
              setTempTabIndexIO,
              setUpdatedTabIndexIO,
              multipleIO,
              setMultipleIO,
              onText,
              offText,
              setIsChangeText,
              setUpdatedTabIndexSquare,
              setTempTabIndexSquare,
              multipleSquare,
              setMultipleSquare,
              tempTabIndexSquare,
              setUpdatedTabIndexCircle,
              setTempTabIndexCircle,
              multipleCircle,
              setMultipleCircle,
              tempTabIndexCircle,
            });
          }}
        >
          save
        </button>
      </div>
    </div>
  );
};

export const ChangeIOColor = ({
  isChangeColor,
  setIsChangeColor,
  currentDevice,
  tempTabIndexIO,
  activeTabIndex,
  tempImages,
  selectedDevice,
  clickedDeviceIndex,
  setTempImages,
  setUpdatedImages,
  setTempTabIndexIO,
  setUpdatedTabIndexIO,
  multipleIO,
  setMultipleIO,
  onColor,
  setOnColor,
  offColor,
  setOffColor,
  handleIOColor,
  setUpdatedTabIndexSquare,
  setTempTabIndexSquare,
  multipleSquare,
  setMultipleSquare,
  tempTabIndexSquare,
  setUpdatedTabIndexCircle,
  setTempTabIndexCircle,
  multipleCircle,
  setMultipleCircle,
  tempTabIndexCircle,
}) => {
  if (!isChangeColor) return null;

  return (
    <div className={styles.addNewTag}>
      <div className={styles.bgColorContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsChangeColor(false)}
        >
          <img src={closeSvg} alt="" />
        </button>

        <div className={styles.changeTextInfo}>
          <span className={styles.bgColorText}>On Text:</span>
          <input
            type="color"
            style={{ cursor: 'pointer' }}
            onChange={(e) => setOnColor(e.target.value)}
          />
        </div>

        <div className={styles.changeTextInfo}>
          <span className={styles.bgColorText}>Off Text:</span>
          <input
            type="color"
            style={{ cursor: 'pointer' }}
            onChange={(e) => setOffColor(e.target.value)}
          />
        </div>

        <button
          className={styles.saveTimePeriod}
          onClick={() =>
            handleIOColor({
              currentDevice,
              tempTabIndexIO,
              activeTabIndex,
              tempImages,
              selectedDevice,
              clickedDeviceIndex,
              setTempImages,
              setUpdatedImages,
              setTempTabIndexIO,
              setUpdatedTabIndexIO,
              multipleIO,
              setMultipleIO,
              onColor,
              offColor,
              setIsChangeColor,
              setUpdatedTabIndexSquare,
              setTempTabIndexSquare,
              multipleSquare,
              setMultipleSquare,
              tempTabIndexSquare,
              setUpdatedTabIndexCircle,
              setTempTabIndexCircle,
              multipleCircle,
              setMultipleCircle,
              tempTabIndexCircle,
            })
          }
        >
          save
        </button>
      </div>
    </div>
  );
};

export const SetLimit = ({
  isSetLimit,
  setIsSetLimit,
  setUpperLimit,
  setLowerLimit,
}) => {
  if (!isSetLimit) return null;

  return (
    <div className={styles.addNewTag}>
      <div className={styles.bgColorContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsSetLimit(false)}
        >
          <img src={closeSvg} alt="Close" />
        </button>

        <div className={styles.changeTextInfo}>
          <span className={styles.bgColorText}>Max Limit:</span>
          <input
            type="text"
            style={{ cursor: 'pointer' }}
            onChange={(e) => setUpperLimit(e.target.value)}
          />
        </div>

        <div className={styles.changeTextInfo}>
          <span className={styles.bgColorText}>Min Limit:</span>
          <input
            type="text"
            style={{ cursor: 'pointer' }}
            onChange={(e) => setLowerLimit(e.target.value)}
          />
        </div>

        <button className={styles.saveTimePeriod}>save</button>
      </div>
    </div>
  );
};

export const HidePopup = ({
  isHidePopup,
  tableData,
  setIsHidePopup,
  setHideChannel,
  setHideValue,
  currentDevice,
  activeTabIndex,
  tempImages,
  selectedDevice,
  clickedDeviceIndex,
  setTempImages,
  setUpdatedImages,
  hideChannel,
  hideValue,
  tempTabIndexSquare,
  setTempTabIndexSquare,
  setUpdatedTabIndexSquare,
  multipleSquare,
  setMultipleSquare,
  tempTabIndexCircle,
  setTempTabIndexCircle,
  setUpdatedTabIndexCircle,
  multipleCircle,
  setMultipleCircle,
  tempTabIndexLines,
  setTempTabIndexLines,
  setUpdatedTabIndexLines,
  multipleLines,
  setMultipleLines,
  setMultipleImages,
  multipleImages,
  setUpdatedTabIndexImages,
  setTempTabIndexImages,
  tempTabIndexImages,

  setMultipleDisplay,
  multipleDisplay,
  setUpdatedTabIndexDisplay,
  setTempTabIndexDisplay,
  tempTabIndexDisplay,

  setMultipleIO,
  multipleIO,
  setUpdatedTabIndexIO,
  setTempTabIndexIO,
  tempTabIndexIO,

  setMultipleMotor,
  multipleMotor,
  setUpdatedTabIndexMotor,
  setTempTabIndexMotor,
  tempTabIndexMotor,

  setMultiplePolygone,
  multiplePolygone,
  setUpdatedTabIndexPolygone,
  setTempTabIndexPolygone,
  tempTabIndexPolygone,

  setMultiplePipe,
  multiplePipe,
  setUpdatedTabIndexPipe,
  setTempTabIndexPipe,
  tempTabIndexPipe,

  setMultipleSwitch,
  multipleSwitch,
  setUpdatedTabIndexSwitch,
  setTempTabIndexSwitch,
  tempTabIndexSwitch,

  setMultipleCheckbox,
  multipleCheckbox,
  setUpdatedTabIndexCheckbox,
  setTempTabIndexCheckbox,
  tempTabIndexCheckbox,

  setMultipleRadio,
  multipleRadio,
  setUpdatedTabIndexRadio,
  setTempTabIndexRadio,
  tempTabIndexRadio,

  setMultipleSlider,
  multipleSlider,
  setUpdatedTabIndexSlider,
  setTempTabIndexSlider,
  tempTabIndexSlider,

  setMultipleLamp,
  multipleLamp,
  setUpdatedTabIndexLamp,
  setTempTabIndexLamp,
  tempTabIndexLamp,

  setMultiplePush,
  multiplePush,
  setUpdatedTabIndexPush,
  setTempTabIndexPush,
  tempTabIndexPush,

  setMultipleLink,
  multipleLink,
  setUpdatedTabIndexLink,
  setTempTabIndexLink,
  tempTabIndexLink,

  setMultipleClock,
  multipleClock,
  setUpdatedTabIndexClock,
  setTempTabIndexClock,
  tempTabIndexClock,
}) => {
  if (!isHidePopup) return null;

  return (
    <div className={styles.addNewTag}>
      <div className={styles.bgColorContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsHidePopup(false)}
        >
          <img src={closeSvg} alt="Close" />
        </button>

        <div className={styles.changeTextInfo}>
          <span className={styles.bgColorText}>Hide Channel : </span>
          <select
            id="hideChannel"
            className={styles.availableChannels}
            onChange={(e) => setHideChannel(e.target.value)}
          >
            <option value="">Select Channel</option>
            {tableData?.map((data, i) => (
              <option key={i}>{data.Header}</option>
            ))}
          </select>
        </div>

        <div className={styles.changeTextInfo}>
          <span className={styles.bgColorText}>Value : </span>
          <input
            type="text"
            style={{ cursor: 'pointer' }}
            onChange={(e) => setHideValue(e.target.value)}
            className={styles.addTextInput}
          />
        </div>

        <button
          className={styles.saveTimePeriod}
          onClick={() =>
            handleHideWidget({
              currentDevice,
              activeTabIndex,
              tempImages,
              selectedDevice,
              clickedDeviceIndex,
              setTempImages,
              setUpdatedImages,
              hideChannel,
              hideValue,
              tempTabIndexSquare,
              setTempTabIndexSquare,
              setUpdatedTabIndexSquare,
              multipleSquare,
              setMultipleSquare,
              setIsHidePopup,
              tempTabIndexCircle,
              setTempTabIndexCircle,
              setUpdatedTabIndexCircle,
              multipleCircle,
              setMultipleCircle,
              tempTabIndexLines,
              setTempTabIndexLines,
              setUpdatedTabIndexLines,
              multipleLines,
              setMultipleLines,
              setMultipleImages,
              multipleImages,
              setUpdatedTabIndexImages,
              setTempTabIndexImages,
              tempTabIndexImages,
              setMultipleDisplay,
              multipleDisplay,
              setUpdatedTabIndexDisplay,
              setTempTabIndexDisplay,
              tempTabIndexDisplay,

              setMultipleIO,
              multipleIO,
              setUpdatedTabIndexIO,
              setTempTabIndexIO,
              tempTabIndexIO,

              setMultipleMotor,
              multipleMotor,
              setUpdatedTabIndexMotor,
              setTempTabIndexMotor,
              tempTabIndexMotor,

              setMultiplePolygone,
              multiplePolygone,
              setUpdatedTabIndexPolygone,
              setTempTabIndexPolygone,
              tempTabIndexPolygone,

              setMultiplePipe,
              multiplePipe,
              setUpdatedTabIndexPipe,
              setTempTabIndexPipe,
              tempTabIndexPipe,

              setMultipleSwitch,
              multipleSwitch,
              setUpdatedTabIndexSwitch,
              setTempTabIndexSwitch,
              tempTabIndexSwitch,

              setMultipleCheckbox,
              multipleCheckbox,
              setUpdatedTabIndexCheckbox,
              setTempTabIndexCheckbox,
              tempTabIndexCheckbox,

              setMultipleRadio,
              multipleRadio,
              setUpdatedTabIndexRadio,
              setTempTabIndexRadio,
              tempTabIndexRadio,

              setMultipleSlider,
              multipleSlider,
              setUpdatedTabIndexSlider,
              setTempTabIndexSlider,
              tempTabIndexSlider,

              setMultipleLamp,
              multipleLamp,
              setUpdatedTabIndexLamp,
              setTempTabIndexLamp,
              tempTabIndexLamp,

              setMultiplePush,
              multiplePush,
              setUpdatedTabIndexPush,
              setTempTabIndexPush,
              tempTabIndexPush,

              setMultipleLink,
              multipleLink,
              setUpdatedTabIndexLink,
              setTempTabIndexLink,
              tempTabIndexLink,

              setMultipleClock,
              multipleClock,
              setUpdatedTabIndexClock,
              setTempTabIndexClock,
              tempTabIndexClock,
            })
          }
        >
          save
        </button>
      </div>
    </div>
  );
};

export const ShowHorizontalMovementPopup = ({
  tableData,
  setIsHorizontalMove,
  setConditionValue,
  setMoveValue,
  conditionValue,
  moveValue,
  setHorizontalMoveChannel,
  currentDevice,
  activeTabIndex,
  tempImages,
  selectedDevice,
  clickedDeviceIndex,
  setTempImages,
  setUpdatedImages,
  tempTabIndexSquare,
  setTempTabIndexSquare,
  setUpdatedTabIndexSquare,
  multipleSquare,
  setMultipleSquare,
  horizontalMoveChannel,

  tempTabIndexCircle,
  setTempTabIndexCircle,
  setUpdatedTabIndexCircle,
  multipleCircle,
  setMultipleCircle,

  tempTabIndexLines,
  setTempTabIndexLines,
  setUpdatedTabIndexLines,
  multipleLines,
  setMultipleLines,

  setMultipleImages,
  multipleImages,
  setUpdatedTabIndexImages,
  setTempTabIndexImages,
  tempTabIndexImages,
}) => {
  const handleLeftConditionChange = (e) => {
    setConditionValue({
      toLeft: e.target.value,
      toRight: conditionValue?.toRight,
      toTop: conditionValue?.toTop,
      toBottom: conditionValue?.toBottom,
    });
  };

  const handleRightConditionChange = (e) => {
    setConditionValue({
      toLeft: conditionValue?.toLeft,
      toRight: e.target.value,
      toTop: conditionValue?.toTop,
      toBottom: conditionValue?.toBottom,
    });
  };

  const handleLeftMoveChange = (e) => {
    setMoveValue({
      toLeft: e.target.value,
      toRight: moveValue?.toRight,
      toTop: moveValue?.toTop,
      toBottom: moveValue?.toBottom,
    });
  };

  const handleRightMoveChange = (e) => {
    setMoveValue({
      toLeft: moveValue?.toLeft,
      toRight: e.target.value,
      toTop: moveValue?.toTop,
      toBottom: moveValue?.toBottom,
    });
  };

  return (
    <div className={styles.addNewTag}>
      <div className={styles.bgColorContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsHorizontalMove(false)}
        >
          <img src={closeSvg} alt="Close" />
        </button>

        <div className={styles.modalHeader}>
          Horizontal Movement Configuration
        </div>

        <div className={styles.changeTextInfo}>
          <span className={styles.bgColorText}>Select Channel : </span>
          <select
            className={styles.availableChannels}
            onChange={(e) => setHorizontalMoveChannel(e.target.value)}
            defaultValue={horizontalMoveChannel}
          >
            <option value="">Select Channel</option>
            {tableData?.map((data, i) => (
              <option key={i}>{data.Header}</option>
            ))}
          </select>
        </div>

        <div className={styles.movementContainer}>
          <div className={styles.moveSideContainer}>
            <span className={styles.moveText}>Condition Value</span>
            <div className={styles.moveValConfig}>
              <label> To Left :</label>
              <input
                type="number"
                defaultValue={conditionValue?.toLeft || 0}
                onChange={(e) => handleLeftConditionChange(e)}
                className={styles.addTextInput}
              />
            </div>
            <div className={styles.moveValConfig}>
              <label> To Right :</label>
              <input
                type="number"
                defaultValue={conditionValue?.toRight || 100}
                onChange={(e) => handleRightConditionChange(e)}
                className={styles.addTextInput}
              />
            </div>
          </div>
          <div className={styles.moveSideContainer}>
            <span>Move Value</span>
            <div className={styles.moveValConfig}>
              <label>At Left End :</label>
              <input
                type="number"
                defaultValue={moveValue?.toLeft || 0}
                onChange={(e) => handleLeftMoveChange(e)}
                className={styles.addTextInput}
              />
            </div>
            <div className={styles.moveValConfig}>
              <label>At Right End :</label>
              <input
                type="number"
                defaultValue={moveValue?.toRight || 100}
                onChange={(e) => handleRightMoveChange(e)}
                className={styles.addTextInput}
              />
            </div>
          </div>
        </div>

        <button
          className={styles.saveTimePeriod}
          onClick={() =>
            handleHorizontalMovementValues({
              currentDevice,
              activeTabIndex,
              tempImages,
              selectedDevice,
              clickedDeviceIndex,
              setTempImages,
              setUpdatedImages,
              tempTabIndexSquare,
              setTempTabIndexSquare,
              setUpdatedTabIndexSquare,
              multipleSquare,
              setMultipleSquare,
              setIsHorizontalMove,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              tempTabIndexCircle,
              setTempTabIndexCircle,
              setUpdatedTabIndexCircle,
              multipleCircle,
              setMultipleCircle,

              tempTabIndexLines,
              setTempTabIndexLines,
              setUpdatedTabIndexLines,
              multipleLines,
              setMultipleLines,

              setMultipleImages,
              multipleImages,
              setUpdatedTabIndexImages,
              setTempTabIndexImages,
              tempTabIndexImages,
            })
          }
        >
          save
        </button>
      </div>
    </div>
  );
};

export const ShowVerticalMovementPopup = ({
  tableData,
  setIsVerticalMove,
  setConditionValue,
  setMoveValue,
  conditionValue,
  moveValue,
  setVerticalMoveChannel,
  currentDevice,
  activeTabIndex,
  tempImages,
  selectedDevice,
  clickedDeviceIndex,
  setTempImages,
  setUpdatedImages,
  tempTabIndexSquare,
  setTempTabIndexSquare,
  setUpdatedTabIndexSquare,
  multipleSquare,
  setMultipleSquare,
  verticalMoveChannel,
  tempTabIndexCircle,
  setTempTabIndexCircle,
  setUpdatedTabIndexCircle,
  multipleCircle,
  setMultipleCircle,

  tempTabIndexLines,
  setTempTabIndexLines,
  setUpdatedTabIndexLines,
  multipleLines,
  setMultipleLines,
  setMultipleImages,
  multipleImages,
  setUpdatedTabIndexImages,
  setTempTabIndexImages,
  tempTabIndexImages,
}) => {
  const handleTopConditionChange = (e) => {
    setConditionValue({
      toLeft: conditionValue?.toLeft,
      toRight: conditionValue?.toRight,
      toTop: e.target.value,
      toBottom: conditionValue?.toBottom,
    });
  };

  const handleBottomConditionChange = (e) => {
    setConditionValue({
      toLeft: conditionValue?.toLeft,
      toRight: conditionValue?.toRight,
      toTop: conditionValue?.toTop,
      toBottom: e.target.value,
    });
  };

  const handleTopMoveChange = (e) => {
    setMoveValue({
      toLeft: moveValue?.toLeft,
      toRight: moveValue?.toRight,
      toTop: e.target.value,
      toBottom: moveValue?.toBottom,
    });
  };

  const handleBottomMoveChange = (e) => {
    setMoveValue({
      toLeft: moveValue?.toLeft,
      toRight: moveValue?.toRight,
      toTop: moveValue?.toTop,
      toBottom: e.target.value,
    });
  };

  return (
    <div className={styles.addNewTag}>
      <div className={styles.bgColorContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsVerticalMove(false)}
        >
          <img src={closeSvg} alt="Close" />
        </button>

        <div className={styles.modalHeader}>
          Vertical Movement Configuration
        </div>

        <div className={styles.changeTextInfo}>
          <span className={styles.bgColorText}>Select Channel : </span>
          <select
            className={styles.availableChannels}
            onChange={(e) => setVerticalMoveChannel(e.target.value)}
            defaultValue={() => setVerticalMoveChannel(verticalMoveChannel)}
          >
            <option value="">Select Channel</option>
            {tableData?.map((data, i) => (
              <option key={i}>{data.Header}</option>
            ))}
          </select>
        </div>

        <div className={styles.movementContainer}>
          <div className={styles.moveSideContainer}>
            <span className={styles.moveText}>Condition Value</span>
            <div className={styles.moveValConfig}>
              <label> To Top :</label>
              <input
                type="number"
                defaultValue={conditionValue?.toTop || 0}
                onChange={(e) => handleTopConditionChange(e)}
                className={styles.addTextInput}
              />
            </div>
            <div className={styles.moveValConfig}>
              <label> To Bottom :</label>
              <input
                type="number"
                defaultValue={conditionValue?.toBottom || 100}
                onChange={(e) => handleBottomConditionChange(e)}
                className={styles.addTextInput}
              />
            </div>
          </div>
          <div className={styles.moveSideContainer}>
            <span>Move Value</span>
            <div className={styles.moveValConfig}>
              <label>At Top End :</label>
              <input
                type="number"
                defaultValue={moveValue?.toTop || 0}
                onChange={(e) => handleTopMoveChange(e)}
                className={styles.addTextInput}
              />
            </div>
            <div className={styles.moveValConfig}>
              <label>At Bottom End :</label>
              <input
                type="number"
                defaultValue={moveValue?.toBottom || 100}
                onChange={(e) => handleBottomMoveChange(e)}
                className={styles.addTextInput}
              />
            </div>
          </div>
        </div>

        <button
          className={styles.saveTimePeriod}
          onClick={() =>
            handleVerticalMovementValues({
              currentDevice,
              activeTabIndex,
              tempImages,
              selectedDevice,
              clickedDeviceIndex,
              setTempImages,
              setUpdatedImages,
              tempTabIndexSquare,
              setTempTabIndexSquare,
              setUpdatedTabIndexSquare,
              multipleSquare,
              setMultipleSquare,
              setIsVerticalMove,
              conditionValue,
              moveValue,
              verticalMoveChannel,
              tempTabIndexCircle,
              setTempTabIndexCircle,
              setUpdatedTabIndexCircle,
              multipleCircle,
              setMultipleCircle,

              tempTabIndexLines,
              setTempTabIndexLines,
              setUpdatedTabIndexLines,
              multipleLines,
              setMultipleLines,
              setMultipleImages,
              multipleImages,
              setUpdatedTabIndexImages,
              setTempTabIndexImages,
              tempTabIndexImages,
            })
          }
        >
          save
        </button>
      </div>
    </div>
  );
};

export const LineStyle = ({
  setIsLineStyle,
  setIsCurveLine,
  isCurveLine,
  setIsSteppedLine,
  isSteppedLine,
  setLineStyle,
  lineStyle,
  tempTabIndexLineChart,
  setTempTabIndexLineChart,
  multipleLineCharts,
  setMultipleLineCharts,
  currentDevice,
  activeTabIndex,
  tempImages,
  selectedDevice,
  clickedDeviceIndex,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexLineChart,
}) => {
  return (
    <div className={styles.addNewTag}>
      <div className={styles.bgColorContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsLineStyle(false)}
        >
          <img src={closeSvg} alt="Close" />
        </button>
        <div className={styles.modalHeader}>Line Style & Options</div>

        <div className={styles.changeTextInfo}>
          <span className={styles.bgColorText}>Select Line Style : </span>
          <select
            id="LineOptions"
            className={styles.availableChannels}
            defaultValue={lineStyle}
            onChange={(e) => setLineStyle(e.target.value)}
          >
            <option value="Line">Line</option>
            <option value="Dash">Dash</option>
            <option value="Fill">Fill</option>
          </select>
        </div>

        <div className={styles.moveSideContainer}>
          <span className={styles.moveText}>Curve Line :</span>
          <select
            id="CurveLine"
            className={styles.availableChannels}
            defaultValue={isCurveLine ? 'True' : 'False'}
            onChange={(e) =>
              setIsCurveLine(e.target.value === 'True' ? true : false)
            }
          >
            <option value="True">True</option>
            <option value="False">False</option>
          </select>
        </div>

        <div className={styles.moveSideContainer}>
          <span className={styles.moveText}>Stepped Line :</span>
          <select
            id="CurveLine"
            className={styles.availableChannels}
            defaultValue={isSteppedLine ? 'True' : 'False'}
            onChange={(e) =>
              setIsSteppedLine(e.target.value === 'True' ? true : false)
            }
          >
            <option value="True">True</option>
            <option value="False">False</option>
          </select>
        </div>

        <button
          className={styles.saveTimePeriod}
          onClick={() => {
            handleLineStyle({
              lineStyle,
              isCurveLine,
              isSteppedLine,
              setIsLineStyle,
              tempTabIndexLineChart,
              setTempTabIndexLineChart,
              multipleLineCharts,
              setMultipleLineCharts,
              currentDevice,
              activeTabIndex,
              tempImages,
              selectedDevice,
              clickedDeviceIndex,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexLineChart,
            });
          }}
        >
          save
        </button>
      </div>
    </div>
  );
};

export const YAxisRange = ({
  setIsYRange,
  yRange,
  tempTabIndexLineChart,
  setTempTabIndexLineChart,
  multipleLineCharts,
  setMultipleLineCharts,
  currentDevice,
  activeTabIndex,
  tempImages,
  selectedDevice,
  clickedDeviceIndex,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexLineChart,
  setYRange,
}) => {
  return (
    <div className={styles.addNewTag}>
      <div className={styles.bgColorContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsYRange(false)}
        >
          <img src={closeSvg} alt="Close" />
        </button>
        <div className={styles.modalHeader}>Y Axis Range</div>

        <div className={styles.changeTextInfo}>
          <span className={styles.moveText}>Y-Axis Max</span>
          <input
            type="number"
            defaultValue={yRange?.max}
            className={styles.addTextInput}
            onChange={(e) =>
              setYRange({ min: yRange?.min, max: e.target.value })
            }
          />
        </div>

        <div className={styles.changeTextInfo}>
          <span className={styles.moveText}>Y-Axis Min</span>
          <input
            type="number"
            defaultValue={yRange?.min}
            className={styles.addTextInput}
            onChange={(e) =>
              setYRange({ min: e.target.value, max: yRange?.max })
            }
          />
        </div>

        <div
          className={styles.saveTimePeriod}
          onClick={() => {
            handleYRange({
              tempTabIndexLineChart,
              setTempTabIndexLineChart,
              multipleLineCharts,
              setMultipleLineCharts,
              currentDevice,
              activeTabIndex,
              tempImages,
              selectedDevice,
              clickedDeviceIndex,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexLineChart,
              setIsYRange,
              yRange,
            });
          }}
        >
          save
        </div>
      </div>
    </div>
  );
};
export const GraphInterval = ({
  setIsGraphInterval,
  xInterval,
  setXInterval,
  yInterval,
  setYInterval,
  tempTabIndexLineChart,
  setTempTabIndexLineChart,
  multipleLineCharts,
  setMultipleLineCharts,
  currentDevice,
  activeTabIndex,
  tempImages,
  selectedDevice,
  clickedDeviceIndex,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexLineChart,
}) => {
  return (
    <div className={styles.addNewTag}>
      <div className={styles.bgColorContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsGraphInterval(false)}
        >
          <img src={closeSvg} alt="Close" />
        </button>
        <div className={styles.modalHeader}>Graph Interval</div>

        <div className={styles.changeTextInfo}>
          <span className={styles.moveText}>Y-Axis Interval</span>
          <input
            type="number"
            className={styles.addTextInput}
            defaultValue={yInterval}
            onChange={(e) => setYInterval(e.target.value)}
          />
        </div>

        <div className={styles.changeTextInfo}>
          <span className={styles.moveText}>X-Axis Interval</span>
          <input
            type="text"
            placeholder="Ex: 1M , 1S OR 1H"
            className={styles.addTextInput}
            onChange={(e) => setXInterval(e.target.value.trim())}
            defaultValue={xInterval}
          />
        </div>

        <div
          className={styles.saveTimePeriod}
          onClick={() => {
            handleGraphInterval({
              tempTabIndexLineChart,
              setTempTabIndexLineChart,
              multipleLineCharts,
              setMultipleLineCharts,
              currentDevice,
              activeTabIndex,
              tempImages,
              selectedDevice,
              clickedDeviceIndex,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexLineChart,
              setIsGraphInterval,
              xInterval,
              yInterval,
            });
          }}
        >
          save
        </div>
      </div>
    </div>
  );
};

export const BlinkPopup = ({
  tableData,
  setIsBlinkPopup,
  blinkChannel,
  setBlinkChannel,
  blinkValue,
  setBlinkValue,
  blinkFrequency,
  setBlinkFrequency,
  blinkFunction,
  setBlinkFunction,
  currentDevice,
  activeTabIndex,
  tempImages,
  selectedDevice,
  clickedDeviceIndex,
  setTempImages,
  setUpdatedImages,
  // Square
  tempTabIndexSquare,
  setTempTabIndexSquare,
  setUpdatedTabIndexSquare,
  multipleSquare,
  setMultipleSquare,

  tempTabIndexCircle,
  setTempTabIndexCircle,
  setUpdatedTabIndexCircle,
  multipleCircle,
  setMultipleCircle,

  multipleImages,
  tempTabIndexImages,
  setTempTabIndexImages,
  setUpdatedTabIndexImages,
  setMultipleImages,

  multipleLines,
  setMultipleLines,
  tempTabIndexLines,
  setTempTabIndexLines,
  setUpdatedTabIndexLines,

  multipleIO,
  tempTabIndexIO,
  setTempTabIndexIO,
  setUpdatedTabIndexIO,
  setMultipleIO,
}) => {
  return (
    <div className={styles.addNewTag}>
      <div className={styles.bgColorContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsBlinkPopup(false)}
        >
          <img src={closeSvg} alt="Close" />
        </button>
        <div className={styles.modalHeader}>Blink</div>

        <div className={styles.changeTextInfo}>
          <span className={styles.moveText}>Select Channel : </span>
          <select
            className={styles.availableChannels}
            onChange={(e) => setBlinkChannel(e.target.value)}
            defaultValue={blinkChannel}
          >
            <option value="">Select Channel</option>
            {tableData?.map((data, i) => (
              <option key={i}>{data.Header}</option>
            ))}
          </select>
        </div>

        <div className={styles.changeTextInfo}>
          <span className={styles.moveText}>Function : </span>
          <select
            className={styles.availableChannels}
            onChange={(e) => setBlinkFunction(e.target.value)}
            defaultValue={blinkFunction}
          >
            <option value="=">=</option>
            <option value=">">&gt;</option>
            <option value="<">&lt;</option>
          </select>
        </div>

        <div className={styles.changeTextInfo}>
          <span className={styles.moveText}>Condition Value:</span>
          <input
            type="number"
            placeholder="Value"
            className={styles.addTextInput}
            onChange={(e) => setBlinkValue(e.target.value)}
            defaultValue={blinkValue}
          />
        </div>

        <div className={styles.changeTextInfo}>
          <span className={styles.moveText}>Frequency:</span>
          <input
            type="number"
            placeholder="Value"
            className={styles.addTextInput}
            onChange={(e) => setBlinkFrequency(e.target.value)}
            defaultValue={blinkFrequency}
          />
          <span className={styles.moveText}>ms</span>
        </div>

        <div
          className={styles.saveTimePeriod}
          onClick={() => {
            handleBlink({
              currentDevice,
              activeTabIndex,
              tempImages,
              selectedDevice,
              clickedDeviceIndex,
              setTempImages,
              setUpdatedImages,
              setIsBlinkPopup,

              // Square
              tempTabIndexSquare,
              setTempTabIndexSquare,
              setUpdatedTabIndexSquare,
              multipleSquare,
              setMultipleSquare,

              // Circle
              tempTabIndexCircle,
              setTempTabIndexCircle,
              setUpdatedTabIndexCircle,
              multipleCircle,
              setMultipleCircle,

              multipleImages,
              tempTabIndexImages,
              setTempTabIndexImages,
              setUpdatedTabIndexImages,
              setMultipleImages,

              multipleLines,
              setMultipleLines,
              tempTabIndexLines,
              setTempTabIndexLines,
              setUpdatedTabIndexLines,

              blinkChannel,
              blinkValue,
              blinkFunction,
              blinkFrequency,

              multipleIO,
              tempTabIndexIO,
              setTempTabIndexIO,
              setUpdatedTabIndexIO,
              setMultipleIO,
            });
          }}
        >
          save
        </div>
      </div>
    </div>
  );
};

export const ChangeValueModal = ({
  setIsChannelUpdateModal,
  vNetSid,
  selectedWidgetChannel,
  tagMap,
  updateValue,
  dispatch,
  setUpdateValue,
  currentDevice,
  setTableData,
}) => {
  return (
    <div className={styles.addNewTag}>
      <div className={styles.changeSVContainer}>
        <button
          className={styles.closeImages}
          onClick={() => setIsChannelUpdateModal(false)}
        >
          <img src={closeSvg} alt="close" />
        </button>

        <h2 className={styles.modalHeader}>Properties</h2>

        <input
          type="number"
          className={styles.changeSVInput}
          onChange={(e) => setUpdateValue(e.target.value)}
          placeholder="Value"
          id="TagValue"
          required
        />

        <button
          className={styles.saveTimePeriod}
          onClick={() => {
            updateTagByName({
              tagName: selectedWidgetChannel,
              value: updateValue,
              dispatch,
              sid: vNetSid,
              tagMap,
              setIsChannelUpdateModal,
              currentDevice,
              setTableData,
            });
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};
